import { Box, styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import MainButton from '../../../components/singleComponents/buttons/MainButton';
import Container from '../../../components/singleComponents/grids/Container';
import Logo from '../../../components/singleComponents/logo/Logo';

// TODO: CRIAR ARQUIVO DE ESTILO PARA CADA UM DOS COMPONENTES / PAGINAS
// QUE ESTÃO USANDO OS ESTILOS QUE TENTARAM COMPARTILHAR AQUI
// APAGAR TODOS E MANTER SÓ O DO ARQUIVO DE LOGIN

export const BaseStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100vw',
  height: '80vh',
  flexDirection: 'row',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const ContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

// TODO: SUBSTITUIR
export const LoginContainerStyled = styled(Box)(() => ({}));

export const LogoContainerStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '25vh',
  [theme.breakpoints.up('md')]: {
    height: '100vh',
    width: '50vw',
  },
}));

export const LogoStyled = styled(Logo)(({ theme }) => ({
  width: '150px',
  [theme.breakpoints.up('md')]: {
    width: '280px',
  },
}));

// T0D0: REMOVER
export const TitleStyled = styled(Typography)({
  display: 'flex',
  padding: '86px 0 79px 0',
  width: '100%',
});

export const ButtonStyled = styled(MainButton)({
  height: '56px',
});

export const ButtonTextStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.white,
  fontWeight: theme.typography.h4.fontWeight,
  textTransform: 'lowercase',
  '&:first-letter': {
    textTransform: 'uppercase',
  },
}));

export const Link2Styled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.gray,
  cursor: 'pointer',
  textDecoration: 'underline',
}));

export const LinkTwoStyled = styled(Link)(({ theme }) => ({
  color: theme.palette.global.gray,
  cursor: 'pointer',
  textDecoration: 'underline',
}));

export const LoginSectionStyled = styled(Container)({
  display: 'flex',
  flexFlow: 'column wrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  padding: '16px',
});

export const TextStyled = styled(Typography)({
  paddingBottom: '24px',
});

export const Subtitle2Styled = styled(Typography)({
  display: 'flex',
  marginBottom: '39px',
  width: '100%',
});

export const InputContainerStyled = styled(Container)({
  display: 'flex',
  width: '100%',
  marginBottom: '32px',
});
